import { render, staticRenderFns } from "./DriversOccupancy.vue?vue&type=template&id=d04bf39e&scoped=true&"
import script from "./DriversOccupancy.vue?vue&type=script&lang=js&"
export * from "./DriversOccupancy.vue?vue&type=script&lang=js&"
import style0 from "./DriversOccupancy.vue?vue&type=style&index=0&id=d04bf39e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04bf39e",
  null
  
)

export default component.exports